import { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { NoDataFoundTable } from "../../../../Hooks/NoDataFoundTable";
import FormFields from "./FormFields";
import FieldCustomize from "./FieldCustomize";

const FormFieldManagement = ({ setOpenHistory }) => {
  const [fields, setFields] = useState([]);
  const [openCustomization, setOpenCustomization] = useState(false)

  return (
    <div className="meta-table p-0">
      <Container fluid>
        <Row>
          <Form.Group
            as={Col}
            md={8}
            className="border-end overflow-auto p-0"
            style={{ height: "calc(100vh - 123px)" }}
          >
            {fields.length === 0 ? (
              <NoDataFoundTable
                MSG={`Click fields from the right toolbar to add them`}
              />
            ) : (
              <div className="p-4">
                {fields.map((field, index) => (
                  <div key={field.id} index={index}>
                    <FormFields field={field} setFields={setFields} setOpenCustomization={setOpenCustomization} />
                  </div>
                ))}
              </div>
            )}
          </Form.Group>

          <Form.Group as={Col} md={4} className="p-0">
            <FieldCustomize
            fields={fields}
            setFields={setFields}
            openCustomization={openCustomization}
            setOpenCustomization={setOpenCustomization}
            setOpenHistory={setOpenHistory}
            />
          </Form.Group>
        </Row>
      </Container>
    </div>
  );
};

export default FormFieldManagement;
